import {AbstractControl, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import * as m from 'moment';

export const isAfter = (after: AbstractControl|m.Moment, format: string): ValidatorFn => {
  let subscribe = false;
  return (control: AbstractControl): ValidationErrors => {
    if (!subscribe && after instanceof AbstractControl) {
      subscribe = true;
      after.valueChanges.subscribe(() => { control.updateValueAndValidity(); });
    }

    if (Validators.required(control) != undefined) {
      return undefined;
    }

    if (after instanceof AbstractControl && Validators.required(after) != undefined) {
      return undefined;
    }

    const x = m(control.value, format, true);
    const y = getValue(after, format, true);
    return x.isAfter(y) ? undefined : { isAfter: true };
  };
};

function getValue(controlOrMoment: AbstractControl|m.Moment, format: string, strict?: boolean): m.Moment {
  if (controlOrMoment instanceof AbstractControl) {
    return m(controlOrMoment.value, format, strict);
  }

  return controlOrMoment;
}
